/**
 * Escolher a capa do perfil (docs/spec/friends.md, "Perfil"): o seletor da capa da mesa, com o Desk
 * Cloud de quem escolhe, o computador (sem ligar à mesa aberta) e o endereço da web. Escolher grava na
 * hora, como o avatar. O meu perfil e Configurações → Perfil usam o mesmo.
 */
import { useT } from '../i18n/index.js';
import { PROFILE_COVER_LIMITS } from '../shared.js';
import { useApp } from '../store.js';
import { ImagePickerDialog } from '../ui/ImagePicker.js';
import { toast } from '../ui/Toaster.js';

const RULES = { types: PROFILE_COVER_LIMITS.types, maxBytes: PROFILE_COVER_LIMITS.maxBytes, maxSide: PROFILE_COVER_LIMITS.side };

export function ProfileCoverPicker({ initial, onClose }: { initial: string | null; onClose: () => void }) {
  const t = useT();
  const save = useApp((s) => s.saveProfile);
  return (
    <ImagePickerDialog
      cloud
      linkRoom={false}
      rules={RULES}
      title={t('profile.cover.title')}
      initial={initial ?? undefined}
      onCancel={onClose}
      onPick={(value) => {
        onClose();
        // não deu: o erro do servidor já aparece no aviso
        void save({ cover: value }).then((ok) => {
          if (ok) toast(t('profile.cover.saved'), 'success');
        });
      }}
    />
  );
}

/** Tira a capa: o perfil volta à faixa na cor da pessoa. */
export function useRemoveCover(): () => void {
  const t = useT();
  const save = useApp((s) => s.saveProfile);
  return () =>
    void save({ cover: null }).then((ok) => {
      if (ok) toast(t('profile.cover.removed'), 'success');
    });
}
